import(/* webpackMode: "eager" */ "/vercel/path0/src/app/admin/(dashboard)/articles/new/page.tsx");
